import { CollectionState } from '../collection-state.interface';

export const initialState: CollectionState = Object.freeze({
  isUpdating: false,
  listOfCollections: [],
  errorMessage: undefined,
  defaultCollectionId: undefined,
});
